import { render, staticRenderFns } from "./PhpList.vue?vue&type=template&id=e1143992&"
import script from "./PhpList.vue?vue&type=script&lang=js&"
export * from "./PhpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports